import { lazy } from 'react';

export const OfferingsPageLazy = lazy(() => import('./offerings'));
